module.exports = __webpack_public_path__ + "media/images/incarcerated_girls/Pencils-p-2000-207ec3fbb4f66c520833f00d573808f3.png";